import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Corsi from "@/pages/Corsi";
import CorsoDetail from "@/pages/CorsoDetail";
import Aziende from "@/pages/Aziende";
import Persone from "@/pages/Persone";
import Docenti from "@/pages/Docenti";
import AnagraficaDetail from "@/pages/AnagraficaDetail";
import Personale from "@/pages/Personale";
import Finanziamenti from "@/pages/Finanziamenti";
import Calendario from "@/pages/Calendario";
import Attivita from "@/pages/Attivita";
import Documenti from "@/pages/Documenti";
import Report from "@/pages/Report";
import Amministrazione from "@/pages/Amministrazione";
import CambioPassword from "@/pages/CambioPassword";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined)
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <img
          src="/indar-logo.png"
          alt="INDAR"
          className="h-16 w-auto animate-pulse"
          data-testid="app-loading-logo"
        />
      </div>
    );
  if (user === null) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.must_change_password) return <CambioPassword />;
  return <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/corsi" element={<Protected><Corsi /></Protected>} />
          <Route path="/corsi/:id" element={<Protected><CorsoDetail /></Protected>} />
          <Route path="/aziende" element={<Protected><Aziende /></Protected>} />
          <Route path="/persone" element={<Protected><Persone /></Protected>} />
          <Route path="/docenti" element={<Protected><Docenti /></Protected>} />
          <Route path="/persone/:id" element={<Protected><AnagraficaDetail kind="persone" /></Protected>} />
          <Route path="/docenti/:id" element={<Protected><AnagraficaDetail kind="docenti" /></Protected>} />
          <Route path="/personale" element={<Protected><Personale /></Protected>} />
          <Route path="/finanziamenti" element={<Protected><Finanziamenti /></Protected>} />
          <Route path="/calendario" element={<Protected><Calendario /></Protected>} />
          <Route path="/attivita" element={<Protected><Attivita /></Protected>} />
          <Route path="/documenti" element={<Protected><Documenti /></Protected>} />
          <Route path="/report" element={<Protected><Report /></Protected>} />
          <Route path="/amministrazione" element={<Protected><Amministrazione /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
